import LearningModuleWrap from "../../components/templates/LearningModuleWrap";
export default LearningModuleWrap;
